import { useState, useCallback } from 'react';

/**
 * Manages open/close state for a dialog or modal.
 * Returns `isOpen`, `open`, `close`, and `toggle` helpers.
 */
export function useDialog(initialOpen = false) {
  const [isOpen, setIsOpen] = useState(initialOpen);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  const toggle = useCallback(() => setIsOpen(prev => !prev), []);

  return { isOpen, open, close, toggle };
}
